/**
 * 分类资源列表 — 表格列宽按内容量级权重比例分配。
 * 名称适中、类型加宽、预览/状态/操作收窄，避免 el-table 默认把余量全给名称列。
 */

const BASE_WEIGHTS = {
  selection: 48,
  name: 128,
  preview: 88,
  previewIos: 92,
  previewAndroid: 92,
  contentPreview: 120,
  type: 168,
  priority: 168,
  lock: 176,
  lockGroup: 120,
  status: 92,
  action: 168,
};

/**
 * 按当前可见列返回权重键序（末列吃余数）。
 *
 * @param {{ profile: string, showLockGroup: boolean, showAction: boolean }} options
 * @returns {string[]}
 */
export function getClassifyResourcesColumnKeys(options = {}) {
  const profile = options.profile || "default";
  const showLockGroup = Boolean(options.showLockGroup);
  const showAction = options.showAction !== false;

  if (profile === "widget" || profile === "icon") {
    const keys = [
      "selection",
      "name",
      "previewIos",
      "previewAndroid",
      "priority",
      "lock",
    ];
    if (showLockGroup) {
      keys.push("lockGroup");
    }
    keys.push("status");
    if (showAction) {
      keys.push("action");
    }
    return keys;
  }

  if (profile === "kaomoji") {
    const keys = [
      "selection",
      "name",
      "contentPreview",
      "type",
      "priority",
      "lock",
    ];
    if (showLockGroup) {
      keys.push("lockGroup");
    }
    keys.push("status");
    if (showAction) {
      keys.push("action");
    }
    return keys;
  }

  const keys = ["selection", "name", "preview", "type", "priority", "lock"];
  if (showLockGroup) {
    keys.push("lockGroup");
  }
  keys.push("status");
  if (showAction) {
    keys.push("action");
  }
  return keys;
}

/**
 * @param {number} containerWidth tableZone clientWidth
 * @param {{ profile?: string, showLockGroup?: boolean, showAction?: boolean }} options
 * @returns {Record<string, number>}
 */
export function computeClassifyResourcesColumnWidths(containerWidth, options = {}) {
  const keys = getClassifyResourcesColumnKeys(options);
  const weightSum = keys.reduce(
    (sum, key) => sum + (BASE_WEIGHTS[key] || 96),
    0
  );
  const raw = Math.floor(Number(containerWidth) || 0);
  const width = raw > 0 ? raw : weightSum;
  const result = {};
  let assigned = 0;

  keys.forEach((key, index) => {
    if (index === keys.length - 1) {
      result[key] = Math.max(width - assigned, BASE_WEIGHTS[key] || 72);
      return;
    }
    const weight = BASE_WEIGHTS[key] || 96;
    const slice = Math.floor((width * weight) / weightSum);
    result[key] = slice;
    assigned += slice;
  });

  return result;
}
